import {
  RecordPropsDefinition,
  ThisTypedComponentOptionsWithRecordProps as TypedOptions,
  FunctionalComponentOptions,
} from 'vue/types/options';
import Vue from 'vue';
import { ScopedSlots, TsxComponent } from 'vue-tsx-support';

export const component: ComponentWrap = () => (options: any) => options;

export interface Component<
  Props = {},
  EventsWithOn = {},
  ScopedSlotArgs = {},
  AdditionalThisAttrs = { $scopedSlots: ScopedSlots<ScopedSlotArgs>, $props: Props },
  Super extends Vue = Vue
  > {
  <Data, Methods, Computed, PropsDef extends RecordPropsDefinition<Props>>(
    options: TypedOptions<AdditionalThisAttrs & Super & Vue, Data, Methods, Computed, Props> & { props?: PropsDef },
  ): TsxComponent<Super, Props, EventsWithOn, ScopedSlotArgs, Data & Methods & Computed & Props>;

  <PropsDef extends RecordPropsDefinition<Props>>(
    options: FunctionalComponentOptions<Props, PropsDef & RecordPropsDefinition<Props>>,
  ): TsxComponent<Super, Props, EventsWithOn, ScopedSlotArgs, Props>;
}

type ComponentWrap = <
  Props = {},
  EventsWithOn = {},
  ScopedSlotArgs = {},
  AdditionalThisAttrs = { $scopedSlots: ScopedSlots<ScopedSlotArgs>, $props: Props },
  Super extends Vue = Vue
  >() => Component<Props, EventsWithOn, ScopedSlotArgs, AdditionalThisAttrs, Super>;
